(function () {
  if (window.__faithfullHomeLoaded) return;
  window.__faithfullHomeLoaded = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ft-scroll]');
    if (!button) return;
    var section = button.closest('[data-ft-carousel]');
    var track = section && section.querySelector('[data-ft-track]');
    if (!track) return;
    var direction = Number(button.getAttribute('data-ft-scroll')) || 1;
    track.scrollBy({ left: track.clientWidth * 0.88 * direction, behavior: 'smooth' });
  });
})();
